const collator = new Intl.Collator(undefined, { numeric: true });

export function areArraysIntersect(arr1 = [], arr2 = [], predicate) {
  return arr1.some((val1) => arr2.some((val2) => predicate(val1, val2)));
}

export function compareObjects(a = {}, b = {}, properties = [], order = []) {
  function getField(obj, prop) {
    if (typeof prop === 'string') {
      return (obj[prop] ?? ' ').toString();
    }

    if (prop.length === 1) {
      return (obj[prop[0]] ?? ' ').toString();
    }

    return getField(obj[prop[0]] ?? {}, prop.slice(1));
  }

  for (let i = 0; i < properties.length; i += 1) {
    const multiplier = order[i] === 'DESC' ? -1 : 1;
    const result = collator.compare(getField(a, properties[i]), getField(b, properties[i])) * multiplier;

    if (result) {
      return result;
    }
  }

  return 0;
}
